import React from 'react';

const PrintView = ({ children }) => (
  <table className={`print`}>
    <thead>
      <tr>
        <td>
          <img alt="header print" src={window.sq.state.site.printHeaderImg} />
        </td>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td>{children}</td>
      </tr>
    </tbody>
    <tfoot>
      <tr>
        <td>
          <img alt="footer print" src={window.sq.state.site.printFooterImg} />
        </td>
      </tr>
    </tfoot>
  </table>
);

export default PrintView;
